import { ApiService } from '../apiService'

/**
 * Deleting your own account (scheduled, with a 30-day grace period).
 *
 * POST schedules it, DELETE cancels it, GET says whether one is scheduled. The account keeps
 * working until `purgeAfter`; signing back in during the grace period is how somebody changes
 * their mind.
 */
export type AccountDeletionState =
  | { status: 'none'; requestedAt?: null; purgeAfter?: null }
  | { status: 'scheduled'; requestedAt: string; purgeAfter: string }

export interface ScheduleAccountDeletionRequest {
  /** Must be exactly "DELETE"; the server refuses anything else. */
  confirmation: 'DELETE'
  /** Required for accounts with a password; Google/Apple accounts need a sign-in in the last 10 minutes instead. */
  currentPassword?: string
  reason?: string
}

export const accountDeletionApi = {
  get: () => ApiService.get<AccountDeletionState>('/api/me/account/deletion'),

  schedule: (data: ScheduleAccountDeletionRequest) =>
    ApiService.post<AccountDeletionState>('/api/me/account/deletion', data),

  cancel: () => ApiService.delete<AccountDeletionState | void>('/api/me/account/deletion'),
}
